/**
 * Shared identity for the organizations-service rankings endpoint. The
 * rankings list route is `POST /v1/rankings/{listKey}` — the `listKey` is a
 * per-placement path segment threaded from the shortcode
 * (`{{context.params.listKey}}`), so the path is matched by prefix rather
 * than an exact string. Centralized here so the response coercer and any
 * future tracking/identity code agree on the signal without importing the
 * coercer.
 */

/** Prefix of the rankings list route: `/v1/rankings/{listKey}`. */
export const RANKINGS_PATH_PREFIX = '/v1/rankings/';

/**
 * True when `path` targets a rankings list route (`/v1/rankings/{listKey}`).
 * A bare `/v1/rankings` or `/v1/rankings/` with no `listKey` segment is not a
 * list route and returns `false`. The `listKey` must be the sole trailing
 * segment — a deeper subroute like `/v1/rankings/{listKey}/foo` returns
 * `false` so the rankings response coercer never runs on a different payload.
 */
export const isRankingsListPath = (path: string): boolean => {
  if (!path.startsWith(RANKINGS_PATH_PREFIX)) return false;
  const segments = path
    .slice(RANKINGS_PATH_PREFIX.length)
    .split('/')
    .filter(Boolean);
  return segments.length === 1;
};
